fragment customerDocumentFragment on CustomerDocument {
  id
  name
  description
  date
  version
  uploader
  active
}
